import React from "react";
import styles from "./styles.module.scss";
import { Token } from "app/utils/stripe";
import AcademyCheckout from "app/components/StripeForm/AcademyCheckout";
import { AcademyPlanCode } from "../PricingToggle";
import { Currency } from "app/utils/currency";

interface IProps {
  onDone?: (token?: Token, reprice?: boolean) => void;
  onCancel?: () => void;
  planCode?: AcademyPlanCode;
  couponCode?: string;
  currency?: Currency;
  isPhased?: boolean;
  phasedSecondAmount?: number;
  purchase?: boolean;
  reprice?: boolean;
  // The trial paywall's buttons (see the Stripe form).
  ctaText?: string;
  showFreePlanButton?: boolean;
  freePlanText?: string;
}

const BillingInformation = ({
  onDone,
  planCode,
  couponCode,
  currency,
  isPhased,
  phasedSecondAmount,
  purchase,
  reprice,
  ctaText,
  showFreePlanButton,
  freePlanText,
}: IProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.divider} />
      <AcademyCheckout
        onToken={onDone}
        planCode={planCode}
        couponCode={couponCode}
        currency={currency}
        isPhased={isPhased}
        phasedSecondAmount={phasedSecondAmount}
        purchase={purchase}
        reprice={reprice}
        ctaText={ctaText}
        showFreePlanButton={showFreePlanButton}
        freePlanText={freePlanText}
      />
    </div>
  );
};

export default BillingInformation;
